import React from 'react'

function Footer() {
  return (
    <footer>
        
        <div className="row">
        <p>Copright &copy; 2022 by Food Adda</p>
        </div>
        
    </footer> 
  )
}

export default Footer